import { ComponentDivElementId } from './Constants';

/**
 * Generates the all-up srcdoc HTML for the iframe
 * @param scriptUrl - The url for the main JavaScript file to be loaded in the iframe
 * @param preconnectUrls - A set of urls that should be preconnected to in order to improve performance
 */
export function generateSrcdocForIframeInside(scriptUrl: string, preconnectUrls?: string[]) {
  return [
    /**/ `<!DOCTYPE ${htmlTag}>`,
    /**/ `<${htmlTag}>`,
    /*  */ `<${headTag}>`,
    /*    */ `<meta charset="utf-8" />`,
    /*    */ ...generatePreconnectTags(preconnectUrls),
    /*    */ generateUrlScriptTagHelper(scriptUrl),
    /*  */ `</${headTag}>`,
    /*  */ `<${bodyTag} style="margin: 0px;">`,
    /*    */ `<${divTag} id="${ComponentDivElementId}"></${divTag}>`,
    /*  */ `</${bodyTag}>`,
    /**/ `</${htmlTag}>`
  ].join('\n');
}

/**
 * Helper function, for generating a simple `<script src="..."></script>` type of text.
 * Exported only for the sake of the companion test file.
 **/
export function generateUrlScriptTagHelper(url: string) {
  return `<${scriptTag} crossorigin="anonymous" src="${url}"></${scriptTag}>`;
}

/**
 * Helper function, for generating simple inlined `<script>...</script>` type of text.
 * Exported only for the sake of the companion test file.
 **/
export function generateInlinedScriptTagHelper(content: string) {
  return [`<${scriptTag}>`, content, `</${scriptTag}>`].join('\n');
}

function generatePreconnectTags(preconnectUrls?: string[]): string[] {
  if (!preconnectUrls) {
    return [];
  }

  return preconnectUrls.map((url) => `<${linkTag} rel="preconnect" href="${url}" crossorigin>`);
}

const htmlTag = 'html';
const headTag = 'head';
const bodyTag = 'body';
const scriptTag = 'script';
const divTag = 'div';
const linkTag = 'link';

// cspell:ignore srcdoc crossorigin
